export function buildCareReferShareMessage(url: string) {
  return `Need help placing someone in care? Start here with Plany365: ${url}`;
}

export function buildReferrerLandingShareMessage(url: string) {
  return `Need to place a resident? Start your referral and manage updates with Plany365 here: ${url}`;
}

export function buildCareProviderLandingShareMessage(url: string) {
  return `Own or manage a care home? Publish your profile, update availability, and receive referrals with Plany365 here: ${url}`;
}

export function buildResidentManagementLandingShareMessage(url: string) {
  return `Need resident management and eMAR for your care team? Explore Plany365 here: ${url}`;
}

export function buildBusinessRegisterShareMessage(url: string) {
  return `Own or manage a care business? Update or claim your care listing on Plany365 to attract referrals, tours, and move-ins here: ${url}`;
}

export function buildBookingStartShareMessage(url: string) {
  return `Need an online booking page for your business? Start here to create your booking page with Plany365: ${url}`;
}

export function buildCareJobsPostShareMessage(url: string) {
  return `Hiring caregivers or care staff? Post your job on Plany365 here: ${url}`;
}

export function buildCareJobsFindShareMessage(url: string) {
  return `Looking for a caregiving job? Browse open care jobs and sign up for free job alerts on Plany365 here: ${url}`;
}
